import { gql } from '@apollo/client';

export const SEARCH_HIERARCHY_GROUPS_QUERY = gql`
  query SalesWebSearchGroups($input: GetClarkeClientsWithCompanyInfoInput!) {
    getAllClarkeClients(input: $input) {
      data {
        id
        name
        legalName
        docType
        docNumber
      }
    }
  }
`;
